import { Routes } from '@angular/router';
import { contactRoutes } from './contact/contact.routes';
import { settingsRoutes } from './settings/settings.routes';
import { SchemesRoutesPatched } from './schemes/schemes-routes.patched';
export const tabsRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then(m => m.HomePage),
  },
  {
    path: 'home/weather',
    loadComponent: () => import('./home/weather/weather.page').then(m => m.WeatherPage),
  },
  {
    path: 'schemes',
    children: SchemesRoutesPatched
  },
  {
    path: 'settings',
    children: settingsRoutes
  },
  {
    path: 'contact',
    children: contactRoutes
  }
]; 